
import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router';
import { mergeStyleSets } from '@uifabric/merge-styles';

import LoginForm from '../../common/client/components/LoginForm';
import Text from '../../common/client/components/Text';

import theme from '../common/theme';

const Content = (props) => {
    if (props.logged) {
        return <Redirect to="/" />;
    }
    return <LoginForm projectId={props.projectId} />;
}

const LoginPage = () => {

    const classNames = mergeStyleSets({
        root: {
            ...theme.styles.flexColumnGrow,
            alignItems: 'center'
        },
        panel: {
            backgroundColor: '#eeeeee',
            marginTop: '128px',
            padding: '8px',
            border: '1px solid #999999'
        },
        title: {
            fontSize: '32px'
        }
    });

    const logged = useSelector(state => {
        return (
            state.auth.data  &&
            state.auth.data.user
        );
    });

    return (
        <div className={classNames.root}>
            <div className={classNames.panel}>
                <Text xxLarge>Přihlášení</Text>
                <Content
                    logged={logged}
                />
            </div>
        </div>
    );
}

export default LoginPage;
